// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: 'AIzaSyCBcblqIxD5WFHVpxQ2Bts5blP7pxgRZXE',
  authDomain: 'fraud-monitoring-3f1c2.firebaseapp.com',
  projectId: 'fraud-monitoring-3f1c2',
  storageBucket: 'fraud-monitoring-3f1c2.appspot.com',
  messagingSenderId: '1050955113566',
  appId: '1:1050955113566:web:b1a680df610b64392940cf',
  measurementId: 'G-Y86B669WP7',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export default app;
